import { useMemo } from "react";
import { AssistantInfo } from "../../../services/api/instances/assistantsApi/types";
import { selectAssistantField } from "../redux/selectors";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";

export const useAssistantField = <K extends keyof AssistantInfo>(field: K) => {
  const selector = useMemo(() => selectAssistantField(field), [field]);

  return useAppSelector(selector);
};
